import { useNotification, useHelpers, useConfig } from "@/composables";
import { ref } from "vue";
import api from "@/services/api";

export const useResendOtp = () => {
    const { showSuccess, showError } = useNotification();
    const { phoneWithoutZero } = useHelpers();
    const { publicMarketOnboardingKey } = useConfig();
    
    const isResending = ref(false);
    const setIsResending = (value) => isResending.value = value;
    
    const cooldown = ref(0);
    const setCooldown = (value) => cooldown.value = value;

    let cooldownInterval = null;

    const startCooldown = () => {
        setCooldown(30);

        if (cooldownInterval) clearInterval(cooldownInterval);

        cooldownInterval = setInterval(() => {
            if (cooldown.value > 0) {
                setCooldown(cooldown.value - 1);
            } else {
                clearInterval(cooldownInterval);
            }
        }, 1000);
    };
    
    const resendOtp = async (data = null) => {
        setIsResending(true);

        let payload = {}

        if(data){
            payload = {
                key: data.key || publicMarketOnboardingKey 
                    + ":" 
                    + phoneWithoutZero(data.phone) ,
                phone: data.phone,
                ttl: 300,
            }
        }

        try {
            await api.post("/otp/send", payload);

            startCooldown();
            showSuccess("OTP sent Successfully")
        } catch (error) {
            console.error("Failed to resend OTP:", error);
            showError('Failed to resend OTP.')
        } finally {
            setIsResending(false);
        }
    };

    return {
        resendOtp,
        cooldown,
        isResending,
    }
}